import { CustomParagraph } from '@/components';
import { Dropdown } from 'antd';
import { useState } from 'react';

interface SettingNotificationFilterProps {
  selectedItem?: string;
  setSelectedItem?: React.Dispatch<React.SetStateAction<string | ''>>;
}

const SettingNotificationFilter: React.FC<SettingNotificationFilterProps> = ({
  selectedItem,
  setSelectedItem,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleMenuClick = (info: { key: string }) => {
    if (info.key === 'all') {
      setSelectedItem?.('All');
    } else if (info.key === 'only_mine') {
      setSelectedItem?.('Only mine');
    }
    setOpen(false);
  };

  const items = [
    {
      key: 'all',
      label: (
        <span>
          <CustomParagraph
            text={'All'}
            fontSize={12}
            lineHeight={'20px'}
            fontWeight={400}
            color='var(--text-primary)'
            marginBottom={0}
          />
        </span>
      ),
    },
    {
      key: 'only_mine',
      label: (
        <span>
          <CustomParagraph
            text={'Only mine'}
            fontSize={12}
            lineHeight={'20px'}
            fontWeight={400}
            color='var(--text-primary)'
            marginBottom={0}
          />
        </span>
      ),
    },
  ];
  return (
    <div>
      <Dropdown
        open={open}
        onOpenChange={setOpen}
        menu={{ items, onClick: handleMenuClick }}
        trigger={['click']}
        placement='bottomRight'
      >
        <button
          className={`setting-notification-filter-btn ${open ? 'open' : 'closed'}`}
        >
          <span className='span-text'>{selectedItem}</span>

          <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M8.295 4.14763L6 6.43763L3.705 4.14763L3 4.85263L6 7.85263L9 4.85263L8.295 4.14763Z'
              fill='currentColor'
            />
          </svg>
        </button>
      </Dropdown>
    </div>
  );
};

export default SettingNotificationFilter;
